/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MdmMatchPreviewOutcomeThresholdsUsed
 */
export interface MdmMatchPreviewOutcomeThresholdsUsed {
    /**
     * 
     * @type {number}
     * @memberof MdmMatchPreviewOutcomeThresholdsUsed
     */
    newRecordFloor?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmMatchPreviewOutcomeThresholdsUsed
     */
    manualReviewThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmMatchPreviewOutcomeThresholdsUsed
     */
    autoMergeThreshold?: number;
}

/**
 * Check if a given object implements the MdmMatchPreviewOutcomeThresholdsUsed interface.
 */
export function instanceOfMdmMatchPreviewOutcomeThresholdsUsed(value: object): value is MdmMatchPreviewOutcomeThresholdsUsed {
    return true;
}

export function MdmMatchPreviewOutcomeThresholdsUsedFromJSON(json: any): MdmMatchPreviewOutcomeThresholdsUsed {
    return MdmMatchPreviewOutcomeThresholdsUsedFromJSONTyped(json, false);
}

export function MdmMatchPreviewOutcomeThresholdsUsedFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmMatchPreviewOutcomeThresholdsUsed {
    if (json == null) {
        return json;
    }
    return {
        
        'newRecordFloor': json['newRecordFloor'] == null ? undefined : json['newRecordFloor'],
        'manualReviewThreshold': json['manualReviewThreshold'] == null ? undefined : json['manualReviewThreshold'],
        'autoMergeThreshold': json['autoMergeThreshold'] == null ? undefined : json['autoMergeThreshold'],
    };
}

export function MdmMatchPreviewOutcomeThresholdsUsedToJSON(json: any): MdmMatchPreviewOutcomeThresholdsUsed {
    return MdmMatchPreviewOutcomeThresholdsUsedToJSONTyped(json, false);
}

export function MdmMatchPreviewOutcomeThresholdsUsedToJSONTyped(value?: MdmMatchPreviewOutcomeThresholdsUsed | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'newRecordFloor': value['newRecordFloor'],
        'manualReviewThreshold': value['manualReviewThreshold'],
        'autoMergeThreshold': value['autoMergeThreshold'],
    };
}

